export const UPDATED_RECENTLY_SECS = 600;
export const UPDATED_VERY_RECENTLY_SECS = 300;
export const POLL_DURATION_SECS = 30000;
export const POLL_LIMIT = 30;
